import { onBeforeUnmount, ref } from "vue";

const DEFAULT_DURATION_MS = 2500;

// Отмена предыдущего таймера перед запуском нового гарантирует, что в любой
// момент есть не более одного отложенного скрытия — быстрый второй тост всегда
// получает свою полную длительность показа.
export function useToast(durationMs = DEFAULT_DURATION_MS) {
  const message = ref("");
  let timer: ReturnType<typeof setTimeout> | undefined;

  const show = (text: string) => {
    message.value = text;
    clearTimeout(timer);
    timer = setTimeout(() => {
      message.value = "";
    }, durationMs);
  };

  const clear = () => {
    clearTimeout(timer);
    message.value = "";
  };

  onBeforeUnmount(clear);

  return { message, show, clear };
}
